export default "__VITE_ASSET__iPHodhf2__ 15149w";